import React, { useEffect, useRef, useState } from "react";

import { tween, styler } from "popmotion";
import { interpolate } from "polymorph-js";
import { MorphPathObject } from "./paths";

export interface MorphSvgProps extends React.HTMLAttributes<HTMLDivElement> {
  morph?: boolean;
  className?: string;
  morphObject: MorphPathObject;
  duration?: number;
}

const MorphSvg: React.FC<MorphSvgProps> = ({
  morph,
  morphObject,
  className,
  duration = 150,
  ...props
}) => {
  const shapeRef = useRef<SVGPathElement>(null);
  const [internalMorph, setInternalMorph] = useState(morph);
  const [startingPath] = useState(morphObject.paths[morph ? 1 : 0]);

  useEffect(() => {
    if (!shapeRef.current) {
      return;
    }

    if (morph !== internalMorph) {
      // get the shape where you want the morphing to be done
      const shape = styler(shapeRef.current);

      // create the morphing effect between the two paths
      const morpher = interpolate(
        morph
          ? [...morphObject.paths]
          : [...morphObject.paths.slice().reverse()]
      );

      // play the tween morphing effect
      tween({
        duration,
      })
        .pipe(morpher)
        .start({
          update: (v: string) => shape.set("d", v),
          complete: () => setInternalMorph(morph),
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [morph, internalMorph, morphObject.paths]);

  return (
    <div className={className} {...props}>
      <svg
        // width={morphObject.width}
        // height={morphObject.height}
        viewBox={`0 0 ${morphObject.width} ${morphObject.height}`}
      >
        <path ref={shapeRef} d={startingPath} fill="currentColor" />
      </svg>
    </div>
  );
};

export { MorphSvg };
